export const mobile = {
    data() {
      return {
        windowWidth: window.innerWidth,
      }
    },
    mounted() {
        window.addEventListener("resize", () => {
          this.windowWidth = window.innerWidth;
        });
    },
    methods: {
        isMobile() {
            if (this.windowWidth) {
              return window.innerWidth <= 767;
            }
          },
    }
  }
  
